import { RouteItem } from '@eastcoal/router/types/route'

import {
  HOUSE_AUCTION_CREATE_PAGE_PATH,
  HOUSE_AUCTION_LIST_PAGE_PATH
} from './constants/path'

export const houseAuctionRoute: RouteItem = {
  title: '竞拍（房屋）',
  hideChildrenInMenu: true,
  children: [
    {
      title: '竞拍（房屋）列表',
      path: HOUSE_AUCTION_LIST_PAGE_PATH,
      Component: () => import('./List')
    },
    {
      title: '新增竞拍（房屋）',
      path: HOUSE_AUCTION_CREATE_PAGE_PATH,
      Component: () => import('./Create')
    }
  ]
}
